import moment from 'moment';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../constants/settings.constants';

export const dateToDateString = (date, withTime = false) => {
  if (!date) {
    return '';
  }
  const momentDate = moment(date);
  return momentDate.isValid() ? momentDate.format(withTime ? DATE_TIME_FORMAT : DATE_FORMAT) : '';
};

export const toHoursAndMinutes = (diff) => {
  const seconds = diff / 1000;
  const hours = Math.floor(seconds / 60 / 60);
  const minutes = seconds / 60 - hours * 60;
  return `${String(hours).padStart(2, 0)}:${String(minutes).padStart(2, 0)}`;
};
